"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendTheme = void 0;
const lodash_1 = require("lodash");
function extendTheme(theme, customizations) {
    return lodash_1.merge({}, theme, customizations);
}
exports.extendTheme = extendTheme;
//# sourceMappingURL=extendTheme.js.map